import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function ShopifyAppBridgeProvider({ children }: Props) {
  return <>{children}</>;
}
